<template>
    <div>
        <ts-loading-banner :loading="loading">
            <form class="form-horizontal">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row form-group m-b-15">
                            <label class="col-md-3 col-form-label required">{{
                                $t('administration.employee.employeeDailyTimescan.attendaceDate')
                            }}</label>
                            <div class="col-md-8">
                                <ts-date-picker-input v-model="model.att_date" :closeOnSelect="true" readonly>
                                </ts-date-picker-input>
                                <div class="validate" v-if="errors.has('att_date')">
                                    {{ errors.first('att_date') }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row form-group m-b-15">
                            <label class="col-md-3 col-form-label required">{{
                                $t('administration.employee.employeeDailyTimescan.employeeName')
                            }}</label>
                            <div class="col-md-8">
                                <input :value="edit_data.employee.name_en" class="form-control" readonly />
                                <div class="validate" v-if="errors.has('staff_id')">
                                    {{ errors.first('staff_id') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row form-group m-b-15">
                            <label class="col-md-3 col-form-label required">{{
                                $t('administration.employee.employeeDailyTimescan.checkIn')
                            }}</label>
                            <div class="col-md-8">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <a-time-picker :value="model.check_in" format="HH:mm" valueFormat="HH:mm"
                                            @change="onChangeCheckIn" />
                                        <div class="validate" v-if="errors.has('check_in')">
                                            {{ errors.first('check_in') }}
                                        </div>
                                    </div>

                                    <div class="col-sm-8">
                                        <div class="row">
                                            <label class="col-md-5 col-form-label">{{
                                                $t('administration.employee.employeeDailyTimescan.checkOut')
                                            }}</label>
                                            <div class="col-md-7">
                                                <a-time-picker @change="onChangeCheckOut" :value="model.check_out"
                                                    format="HH:mm" valueFormat="HH:mm" />
                                                <div class="validate" v-if="errors.has('check_out')">
                                                    {{ errors.first('check_out') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row form-group mb-15">
                            <label class="col-md-3 col-form-label required">{{
                                $t('administration.employee.employeeDailyTimescan.attStatus')
                            }}</label>
                            <div class="col-md-8">
                                <select v-model="model.att_status" style="width: 100%;" class="form-control">
                                    <option :value="null">{{ $t('select') }}</option>
                                    <option v-for="(att, index) in attStatus" :key="index" :value="att.value">
                                        {{ att.att_status }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="model.att_status == 'Present'">
                    <div class="col-sm-12">
                        <div class="row form-group mb-15">
                            <label class="col-md-3 col-form-label"> {{
                                $t(
                                    'administration.employee.employeeDailyTimescan.statusLate'
                                )
                            }}</label>

                            <div class="col-md-8">
                                <a-select v-model="model.att_pnt_status" placeholder="All">

                                    <a-select-option value="Late">Late</a-select-option>
                                    <a-select-option value="On Time">On Time</a-select-option>

                                </a-select>

                            </div>
                        </div>
                    </div>
                </div>
              
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row form-group m-b-15">
                            <label class="col-md-3 col-form-label required">{{
                                $t('campusAttendance.remarks')
                            }}</label>
                            <div class="col-md-8">
                                <textarea v-model="model.att_description" class="form-control" rows="5"></textarea>
                                <div class="validate" v-if="errors.has('att_description')">
                                    {{ errors.first('att_description') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 text-right">
                        <ts-button class="btn-default mr-2" @click.prevent="$emit('close')">{{ $t('cancel')
                        }}</ts-button>

                        <ts-button class="btn-primary" @click.prevent="update" :waiting="waiting">{{ $t('update')
                        }}</ts-button>
                    </div>
                </div>
            </form>
        </ts-loading-banner>
    </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { values } from 'lodash'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            loading: false,
            errors: new Errors(),
            saving: false,
            waiting: false,
            model: {
                check_in: null,
                check_out: null,
                att_status: null,
                att_description: null,
                att_date: null,
                department_id: [],
                att_pnt_status: null
            },
            attStatus: [
                {
                    value: 'Present',
                    att_status: 'Present'
                },
                {
                    value: 'Absent',
                    att_status: 'Absent'
                },
                {
                    value: 'Leave',
                    att_status: 'Leave'
                },
                {
                    value: 'DayOff',
                    att_status: 'Day Off'
                }
            ],
        }
    },
    created() {
        this.setEditData()
    },
    computed: {
        ...mapState('employeeDailyTimescan', ['edit_data'])
    },
    methods: {
        onChangeCheckIn(moment, check_in) {
            this.model.check_in = check_in
        },
        onChangeCheckOut(moment, check_out) {
            this.model.check_out = check_out
        },

        update() {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('employeeDailyTimescan/update', this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.waiting = false
                    this.$emit('close')
                    this.$emit('fetchData')
                })
                .catch(error => {
                    this.waiting = false
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },


        setEditData() {
            this.model.check_in = this.edit_data.t1
            this.model.check_out = this.edit_data.t2
            this.model.att_description = this.edit_data.att_description
            this.model.att_status = this.edit_data.att_status
            this.model.att_date = this.edit_data.att_date
            this.model.staff_id = this.edit_data.staff_id
            this.model.att_pnt_status = this.edit_data.att_pnt_status

        },


    }
}
</script>